import { XMarkIcon } from "@heroicons/react/24/outline";
import { useRef } from "react";
import { useClickOutsideBlock } from "../../helpers/useClickOutside";
import { LoaderSpinner } from "../LoaderSpinner";

export const ReportModal = ({
    isOpen,
    cancelClick,
    reportDataIsLoading,
    reportData,
    testId
}) => {
    const modalRef = useRef(null);
    useClickOutsideBlock(modalRef, cancelClick);
    if (!isOpen) return null;
    return (
        <div 
            aria-hidden="true" 
            className="fixed inset-0 z-40 flex items-center justify-center w-full h-full overflow-y-auto"
            data-testid={testId}
        >
            <div className="fixed inset-0 bg-gray-700 opacity-30" />
            <div 
                ref={modalRef} 
                className="relative p-4 w-full max-w-2xl bg-white border rounded-md shadow-lg z-50 max-h-[90vh] overflow-y-auto"
            >
                <div className="flex justify-end">
                    <button 
                        onClick={cancelClick}
                        data-testid={testId ? `xmark-button-${testId}` : undefined}
                        className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-primary hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        <XMarkIcon className="h-4 w-4" aria-hidden="true" />
                    </button>
                </div>
                {reportDataIsLoading ? (
                    <LoaderSpinner width="25" height="25" border="3" colorSpinner="black" />
                ) : (
                    <>
                        {/* TODO */}
                    </>
                )}
            </div>
        </div>
    )
}